import { Menu, Moon, Sun } from 'lucide-react'
import { toggleTheme } from '@/hooks/useTheme'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

interface ShellMobileHeaderProps {
  mobileMenuOpen: boolean
  logoHorizontal: string
  theme: string
  onToggleMenu: () => void
}

export function ShellMobileHeader({
  mobileMenuOpen,
  logoHorizontal,
  theme,
  onToggleMenu,
}: ShellMobileHeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-14 border-b border-border bg-card/95 backdrop-blur-xl flex items-center justify-between px-4">
      <div className="flex items-center">
        <Button
          variant="ghost"
          size="icon"
          onClick={onToggleMenu}
          className="h-9 w-9 mr-3"
          aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
        >
          <Menu className="h-5 w-5" />
        </Button>
        <img
          src={logoHorizontal}
          alt="AMPERSAND"
          className="h-7 max-w-[160px] object-contain"
        />
      </div>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleTheme}
            className="h-9 w-9"
            aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {theme === 'dark' ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {theme === 'dark' ? 'Light mode' : 'Dark mode'}
        </TooltipContent>
      </Tooltip>
    </header>
  )
}
